/**
 * The save sequence My Account and Firm Profile share (DEDUP-1 b).
 *
 * Busy on, old errors and notice cleared, the call, then the success notice —
 * or the server's error list — and busy off either way. Each caller passes
 * only what differs: its busy flag, the call (endpoint + payload + what to do
 * with the response) and its success notice.
 */
import { extractErrors } from './firmProfile/model'

export interface SaveAction<N> {
  setBusy: (busy: boolean) => void
  setErrors: (errors: string[]) => void
  setNotice: (notice: N | null) => void
  call: () => Promise<unknown>
  success: N
}

export async function runSave<N>({ setBusy, setErrors, setNotice, call, success }: SaveAction<N>) {
  setBusy(true)
  setErrors([])
  setNotice(null)
  try {
    await call()
    setNotice(success)
  } catch (err) {
    setErrors(extractErrors(err))
  } finally {
    setBusy(false)
  }
}
